import _extends from "@babel/runtime/helpers/esm/extends";
// TODO

const common = theme => ({
  zIndex: 100,
  bgcolor: theme.palette.common.white
});
const checkboxCellStyles = theme => _extends({}, common(theme), {
  minWidth: theme.spacing(5),
  paddingLeft: theme.spacing(1.75),
  // 14px
  paddingRight: theme.spacing(),
  whiteSpace: 'nowrap',
  position: 'sticky',
  left: 0,
  zIndex: 101
});
const menuCellStyles = theme => _extends({}, common(theme), {
  paddingRight: 0,
  minWidth: '60px',
  width: '60px',
  whiteSpace: 'nowrap',
  position: 'sticky',
  right: 0,
  zIndex: 101
});
const commonCellStyles = theme => _extends({
  paddingRight: 0,
  minWidth: 125
}, common(theme));
const firstCommonCellStyles = theme => _extends({
  paddingRight: 0,
  paddingLeft: theme.spacing(3.25),
  // 26px
  minWidth: 125
}, common(theme));
const getStyles = (isCheckbox, isMenu, isFirstElement) => {
  if (isCheckbox) {
    return checkboxCellStyles;
  }
  if (isMenu) {
    return menuCellStyles;
  }
  if (isFirstElement) {
    return firstCommonCellStyles;
  }
  return commonCellStyles;
};
const getDefaultStylesAndProps = (isCheckbox, isMenu, isFirstElement) => {
  const styles = getStyles(isCheckbox, isMenu, isFirstElement);
  const checkboxProps = {
    width: 0.1,
    align: 'center'
  };
  const commonProps = {
    variant: 'head'
  };
  const props = isCheckbox ? _extends({}, commonProps, checkboxProps) : commonProps;
  return {
    styles,
    props
  };
};
export default getDefaultStylesAndProps;